
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"auditPeriodInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditPeriod"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doInterview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mayChooseInterview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"auditor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastname"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":172}};
    doc.loc.source = {"body":"fragment auditPeriodInfo on AuditPeriod {\n  id\n  year\n  closedAt\n  attachmentEnabled\n  doInterview\n  mayChooseInterview\n  auditor {\n    id\n    firstname\n    lastname\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
